module.exports = __webpack_public_path__ + "img/advantage5.79eb2404.png";